import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { updateFacilityIds } from '../../app/store/config/configActions';


export default function useGetFacilityIds() {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id') as string;

    const dispatch = useDispatch() 
    useEffect(() => {
      dispatch(updateFacilityIds(id));
      //eslint-disable-next-line
    }, [id])
 
    


    
}

